"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PaypalPaymentLinkRel = void 0;
exports.PaypalPaymentLinkRel = {
    Self: "self",
    ApprovalUrl: "approval_url",
    Execute: "execute",
};
//# sourceMappingURL=PaypalPaymentLinkRel.js.map